<template>
    <div class="sal-filter__checkboxes">
        <div class="col-12" v-if="filter.title">
            <p class="filter__label group__label">{{ filter.title }}</p>
        </div>
        <div class="filter__group col-12">
            <global-input-checkbox
                v-for="option in availableOptions"
                :key="option.value || option"
                :value="isOptionSelected(option)"
                @input="toggleOption(option)"
                :label="option.title || option.value || option"
                :disabled="$store.state.freeze"
                :title="checkboxTitle(option)">
            </global-input-checkbox>
        </div>
    </div>
</template>

<script>
import GlobalButton from '@global/global-elements/global-button/global-button';
import GlobalInputCheckbox from "@global/global-elements/global-input-checkbox/global-input-checkbox.vue";

export default {
    name: "SalFilterCheckboxes",
    components: {GlobalInputCheckbox, GlobalButton},
    props: {
        filter: Object
    },
    computed: {
        availableOptions() {
            return this.filter.options;
        }
    },
    methods: {
        checkboxTitle: function(option) {
            if (option.footnote === undefined) {
                return '';
            }
            let tmp = document.createElement("DIV");
            tmp.innerHTML = option.footnote;
            let title = tmp.textContent || tmp.innerText || "";
            title = title.replaceAll(/\s{2,}/g, ' ');
            return title.trim();
        },
        isOptionSelected: function(option) {
            const selectedValues = this.$store.getters.selectedFilters[this.filter.name] || []
            if (option.value) {
                return selectedValues.includes(option.value);
            }
            return selectedValues.includes(option);
        },
        toggleOption: function(optionToToggle) {

            const value = optionToToggle.value;
            if (this.$store.getters.selectedFilters[this.filter.name]) {
                const found = this.$store.getters.selectedFilters[this.filter.name].some(val => val === value);
                if (found){
                    this.$store.dispatch('removeFilterState', { filterName: this.filter.name, value: value });
                } else {
                    this.$store.dispatch('setFilterState', { filterName: this.filter.name, value: value })
                }
            } else {
                this.$store.dispatch('setFilterState', { filterName: this.filter.name, value: value })
            }
        }
    }
}
</script>
